import * as _ from 'lodash';

import Flex from '../../generic/Flex';
import LabeledCheckbox from '../../generic/Forms/LabeledCheckbox';
import LabeledNumberInput from '../../generic/Forms/LabeledNumberInput';
import type {
  ContractProps,
  UpdateContractPropertyFunction,
} from '../../../hooks/subscriptions/useCurrentOrgContractProps';

export const defaultReleaseGroupLimit = 5;
export const defaultContributorLimit = 100;

type EnterpriseBillingOptionsParams = {
  contractProps: ContractProps;
  updateContractProperty: UpdateContractPropertyFunction;
};

type LimitString = {
  limit?: number | null;
  unlimited?: boolean | null;
  defaultLimit: number;
};

function getLimitString({ limit, unlimited, defaultLimit }: LimitString): string {
  const stringLimit = _.isNil(limit) ? defaultLimit.toString() : limit.toString();
  return unlimited ? '' : stringLimit;
}

export const EnterpriseBillingOptions = ({ contractProps, updateContractProperty }: EnterpriseBillingOptionsParams) => {
  const currentReleaseGroupLimit = getLimitString({
    limit: contractProps.releaseGroupLimit,
    unlimited: contractProps.unlimitedReleaseGroups,
    defaultLimit: defaultReleaseGroupLimit,
  });
  const currentContributorLimit = getLimitString({
    limit: contractProps.contributorLimit,
    unlimited: contractProps.unlimitedContributors,
    defaultLimit: defaultContributorLimit,
  });
  const parsedReleaseGroupLimit = parseInt(currentReleaseGroupLimit, 10);
  const parsedContributorLimit = parseInt(currentContributorLimit, 10);

  return (
    <Flex grow={1} align="flex-start" justify="space-evenly" gap={10}>
      <Flex direction="column" grow={1} align="flex-start" justify="space-evenly" gap={10}>
        <LabeledNumberInput
          labelVariant="legacy"
          label="Release Group Limit"
          value={parsedReleaseGroupLimit}
          min={0}
          isDisabled={contractProps?.unlimitedReleaseGroups}
          onChange={(val) => updateContractProperty('releaseGroupLimit', parseInt(val, 10) || 0)}
        />
        <LabeledCheckbox
          label="Unlimited Release Groups"
          isChecked={contractProps?.unlimitedReleaseGroups}
          onChange={() => updateContractProperty('unlimitedReleaseGroups', !contractProps?.unlimitedReleaseGroups)}
        />
      </Flex>
      <Flex direction="column" grow={1} align="flex-start" justify="space-evenly" gap={10}>
        <LabeledNumberInput
          labelVariant="legacy"
          label="Contributor Limit"
          value={parsedContributorLimit}
          min={0}
          isDisabled={contractProps?.unlimitedContributors}
          onChange={(val) => updateContractProperty('contributorLimit', parseInt(val, 10) || 0)}
        />
        <LabeledCheckbox
          label="Unlimited Contributors"
          isChecked={contractProps?.unlimitedContributors}
          onChange={() => updateContractProperty('unlimitedContributors', !contractProps?.unlimitedContributors)}
        />
      </Flex>
    </Flex>
  );
};
